@if (data.hasOwnProperty('id') || loading) {
  <div class="cw-module-card">
    @if (!editMode && !loading) {
      <div class="cw-flex-row">
        <!-- Modul-Titel -->
        <h2>{{ data.entry_name }}</h2>
        <!-- Toolbar -->
        <phscw-toolbar
          componentIdentifier="helpText"
          [componentConnection]="$any(this)"
          [buttonEditmode]="allowEditmode"
          [buttonHistory]="historyMenuData.length > 0"
          [buttonHistoryMenuData]="historyMenuData"
          [buttonAddLink]="buttonAddLinkVisible"
          [buttonAddLinkParameter]="data"
          buttonAddLinkTooltip="{{ 'GLOBAL.HELP.TEXT.ADDLINK' | translate }}"
          [fullscreenSize]="75">
        </phscw-toolbar>
      </div>
    }
    @if (data && !loading) {
      <form #helpentriesDataForm="ngForm" (ngSubmit)="clickSave()" #spy>
        <!-- Titel -->
        @if (editMode && !loading) {
          <phscw-input-text
            name="entry_name"
            [editMode]="editMode"
            [(ngModel)]="data.entry_name"
            [required]="true">
          </phscw-input-text>
        }
        @if (displayLengthError) {
          <p class="error">
            {{ 'GLOBAL.HELP.TEXT.ERRORTITLELENGTH' | translate: {length: allowedTitleLength} }}
          </p>
        }
        <!-- HTML-Text -->
        @if (!loading) {
          <phscw-input-html-editor name="entry_text" [editMode]="editMode" [(ngModel)]="data.entry_text">
          </phscw-input-html-editor>
        }
        <!-- Sortierung -->
        @if (sortFieldVisible && !loading && editMode) {
          <phscw-input-number
            [editMode]="editMode"
            name="entry_sort"
            inputId="entry_sort"
            label="{{ 'GLOBAL.HELP.TEXT.SORT' | translate }}"
            [(ngModel)]="data.entry_sort">
          </phscw-input-number>
        }
        <!-- Speichern & Abbrechen Buttons -->
        @if (!loading) {
          <div class="cw-button-wrapper">
            @if (!editMode && data.tree_level < maxLevels && allowNewHelpentry) {
              <button
                mat-raised-button
                color="accent"
                type="button"
                (click)="newEntry(data.id)">
                {{ 'GLOBAL.HELP.NEWSUBENTRY' | translate }}
              </button>
            }
            @if (editMode) {
              <button
                mat-raised-button
                color="accent"
                type="button"
                (click)="clickSave()"
                [disabled]="!helpentriesDataForm.form.valid || loading || saving">
                {{ 'GENERAL.SAVE' | translate }}
              </button>
            }
            @if (editMode) {
              <button mat-raised-button color="primary" type="button" (click)="clickCancel()">
                {{ 'GENERAL.CANCEL' | translate }}
              </button>
            }
          </div>
        }
      </form>
    }
    <div [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></div>
  </div>
}
